import { render } from "./ClassOrTagsLine.vue?vue&type=template&id=8d453900&ts=true"
import script from "./ClassOrTagsLine.vue?vue&type=script&lang=ts"
export * from "./ClassOrTagsLine.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__